import { Type } from 'class-transformer';
import { Jurisdiction } from '../definition/jurisdiction.model';

// @dynamic
export class Profile {
  user: {
    idam: {
      id: string,
      email: string
      name: string,
      roles: string[]
    }
  };

  channels: string[];

  @Type(() => Jurisdiction)
  jurisdictions: Jurisdiction[];

  default: {
    workbasket: {
      jurisdiction_id: string,
      case_type_id: string,
      state_id: string
    }
  };

  isSolicitor(): boolean {
    return false;
  }

  isCourtAdmin(): boolean {
    return false;
  }
}
